// extracted by mini-css-extract-plugin
export var required = "_de-0";